import { mxgraphInstance } from './mxgraphFactory';
/**
 * Editor
 */
export var mxDefaultKeyHandler = mxgraphInstance.mxDefaultKeyHandler;
export var mxDefaultPopupMenu = mxgraphInstance.mxDefaultPopupMenu;
export var mxDefaultToolbar = mxgraphInstance.mxDefaultToolbar;
export var mxEditor = mxgraphInstance.mxEditor;
//# sourceMappingURL=Editor.js.map